import { supabaseClient } from 'supabase'
import { RawItemRow } from './deskTypes'

/**
 * The columns the candidate screen shows of the source post: the text, the
 * link, every image, and why the editor discarded it (if it did). Claim and
 * hash bookkeeping columns are left out on purpose.
 */
export const DESK_RAW_ITEM_COLUMNS =
  'id, source, source_url, beat, content, image_path, extra_image_paths, posted_at, first_seen_at, status, status_reason, payload'

export type DeskRawItem = Pick<
  RawItemRow,
  | 'id'
  | 'source'
  | 'source_url'
  | 'beat'
  | 'content'
  | 'image_path'
  | 'extra_image_paths'
  | 'posted_at'
  | 'first_seen_at'
  | 'status'
  | 'status_reason'
  | 'payload'
>

/** The raw item (source post) behind a candidate. Admin-only through RLS. */
export const queryDeskRawItem = async (rawItemId: number): Promise<DeskRawItem> => {
  const { data, error } = await supabaseClient
    .from('raw_items')
    .select(DESK_RAW_ITEM_COLUMNS)
    .eq('id', rawItemId)
    .single()

  if (error) {
    throw error
  }
  return data
}
